import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';

import { useHiddenDomElement } from '@interlayer/js/app/hooks/useHiddenDomElement';

export const useShowSideMenuLeftData = () => {
    // @ts-ignore Test test tes
    const showMobileMenu = useAppSelector(prop('showMobileMenu')) as boolean;

    return useHiddenDomElement({ isReady: showMobileMenu });
};
